// extracted by mini-css-extract-plugin
export default {"eventDetailShareCard":"EventDetails_eventDetailShareCard__OSyRq","eventDetailShare":"EventDetails_eventDetailShare__CHeov"};